<template>
  <div id="calories-burned">
    <form @submit.prevent="calculate">
      <div>
        <select v-model="gender" id="gender">
          <option value="">Płeć</option>
          <option value="m">Mężczyzna</option>
          <option value="k">Kobieta</option>
        </select>
      </div>
      <div>
        <input type="number" v-model.number="age" placeholder="Wiek (lat)">
      </div>
      <div>
        <input type="number" v-model.number="weight" placeholder="Waga (kg)">
      </div>
      <div>
        <input v-model.number="heart_rate" placeholder="Tętno BPM">
      </div>
      <div>
        <input v-model.number="time" placeholder="Czas trwania (min)">
      </div>
      <input type="submit" value="Oblicz">
    </form>
    <div v-if="displayFields">
        <div class="calories-burned">
          Spalone kalorie:
          <div>{{this.result}}</div>
        </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CaloriesBurn',
  methods: {
    calculate: function() {
			let duration = this.time / 60; //

			if ( this.gender === 'm' ) {
				this.result = ((-55.0969 + (0.6309 * Number(this.heart_rate)) + (0.1988 * Number(this.weight)) + (0.2017 * Number(this.age)))/4.184) * 60 * Number(duration);
			}
			else if ( this.gender === 'k' ) {
				this.result = ((-20.4022 + (0.4472 * Number(this.heart_rate)) - (0.1263 * Number(this.weight)) + (0.074 * Number(this.age)))/4.184) * 60 * Number(duration);
			}

      this.result =  Math.round(this.result);
      this.displayFields = true;
    }
  },
  data() {
    return {
      result: 0,
      gender: '',
      age: null,
      weight: null,
      heart_rate: null,
      time: null,
      displayFields: false
    }
  }
}
</script>

